import VueCookie from 'vue-cookie'
import store from '@/store'
import {networkService as network} from '@/services'

export const boothTypesService = {

  getBoothTypes(exhibitionHallId) {
    return new Promise((resolve, reject) => {
      network
        .get(`/booth-types/all/${exhibitionHallId}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getBoothType(id) {
    return new Promise((resolve, reject) => {
      network
        .get(`/booth-types/${id}`)
        .then((data) => {
          resolve(data.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  getBoothTypeByName(exhibitionHallId, name) {
    return new Promise((resolve, reject) => {
      network
        .get(`/booth-types/all/${exhibitionHallId}`)
        .then((data) => {
          let res = {};
          data.data.forEach((item, index) => {
            if(item.name === name) {
              res = item;
            }
          })

          resolve(res);
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
}
